<template>
<dropdown :is-active.sync="isActive" class="is-right flag-dropdown">
  <a class="flag" @click.prevent="toggleDropdown" v-click-outside="closeDropdown">
    <img :src="flag" />
  </a>
  <template slot="dropdown-content">
    <a class="dropdown-item flag" data-lang="en" @click.prevent="onChangeLang"><img src="@/assets/flag-gb.svg" /></a>
    <a class="dropdown-item flag" data-lang="es" @click.prevent="onChangeLang"><img src="@/assets/flag-ch.svg" /></a>
  </template>
</dropdown>
</template>

<script>
import Dropdown from '@/components/general/dropdown'
import ClickOutside from 'vue-click-outside'
import flagGB from '@/assets/flag-gb.svg'
import flagCH from '@/assets/flag-ch.svg'

export default {
  components: { Dropdown },
  methods: {
    toggleDropdown () {
      this.isActive = !this.isActive
    },
    closeDropdown () {
      this.isActive = false
    },
    onChangeLang (e) {
      const lang = e.currentTarget.getAttribute('data-lang')
      this.$i18n.locale = lang
      this.$localStorage.set('locale', lang)
      this.changeFlag(lang)
    },
    changeFlag (lang) {
      this.flag = this.flags[lang] || flagGB
    }
  },
  mounted () {
    const locale = this.$localStorage.get('locale')
    if (locale) {
      this.$i18n.locale = locale
      this.changeFlag(locale)
    }
  },
  data () {
    return {
      isActive: false,
      flag: flagGB,
      flags: {
        'en': flagGB,
        'zh': flagCH
      }
    }
  },
  directives: {
    ClickOutside
  }
}

</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.flag-dropdown {
  margin-left: -8px;
  margin-top: 4px;

  .flag {
    text-decoration: none;
    font-size: 1.2rem;
  }

  .dropdown-item {
    height: 37px;
    padding-top: 6px;
  }
}

.flag-dropdown /deep/ .dropdown-menu {
  width: 53px;
  min-width: 53px;
  padding-top: 0rem;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
}

</style>



// WEBPACK FOOTER //
// src/components/navbar/flag-dropdown.vue